export const Role = {
    DATASET_CREATE: 'cestel-dataset-create',
    ADMIN_GROUPS: 'cestel-admin-groups',
    ADMIN_USERS: 'cestel-admin-users',
    DATASET_PUBLISH: 'cestel-dataset-publish',
    DATASET_DELETE: 'cestel-dataset-delete',
    AUDIT_READ: 'cestel-audit-read',
    DATALAKE_ACCESS: 'cestel-datalake-access'
}
